import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/node_modules/@mundogamernetwork/shared-ui/middleware/auth.global.ts";
import global_45auth_45global from "/app/middleware/global-auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  global_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-middleware": () => import("/app/middleware/auth-middleware.ts"),
  "guest-middleware": () => import("/app/middleware/guest-middleware.ts"),
  "requires-password-confirmation": () => import("/app/middleware/requires-password-confirmation.ts")
}